import React, {PureComponent, MouseEvent} from "react";
import {FormattedMessage} from "react-intl";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {LocaleContext} from "../context/LocaleContext";
import {languageLabels} from "../resources/locales";
import {AdobeAnalyticsContextData} from "../context/AdobeAnalyticsContext";

const logo = require("../resources/img/logo.svg");

const menuLinks = [
    {label: "footer.links.ubi_link_label", url: "https://ubisoft.com", name: "ubisoft.com"},
    {label: "footer.links.terms_of_use_label", url: "https://legal.ubi.com/UplayPlusSubscriptionTerms/", name: "terms of use"},
    {label: "footer.links.privacy_policy_label", url: "https://legal.ubi.com/privacypolicy", name: "privacy policy"},
    {label: "footer.links.legal_label", url: "https://legal.ubi.com/LegalInfoUbisoftEMEA/", name: "legal"},
];

interface Props {
    analytics: AdobeAnalyticsContextData;
}

export default class FooterSection extends PureComponent<Props> {
    static contextType = LocaleContext;
    context!: React.ContextType<typeof LocaleContext>;

    menuLinkItems: HTMLLIElement[];
    footerContainer: any;

    constructor(props: Props) {
        super(props);

        this.menuLinkItems = [];
        this.footerContainer = React.createRef();
    }

    componentDidMount(): void {
        this.handleFooterMenuSize();
        window.addEventListener('orientationchange', this.handleOrientationChange);
    };

    handleOrientationChange = () => {
        setTimeout(() => {
            this.handleFooterMenuSize()
        }, 1000);
    };

    componentWillUnmount(): void {
        window.removeEventListener('orientationchange', this.handleOrientationChange);
    }

    handleFooterMenuSize = () => {
        let footerContainerWidth = this.footerContainer.current.getBoundingClientRect().width;
        let rowWidth = this.menuLinkItems[0].getBoundingClientRect().width;
        for(let i = 0; i < this.menuLinkItems.length - 1; i++) {
            let nextFooterItemWidth = this.menuLinkItems[i+1].getBoundingClientRect().width;
            if(rowWidth + nextFooterItemWidth <= footerContainerWidth) {
                this.menuLinkItems[i].className = 'separator';
                rowWidth += nextFooterItemWidth;
            } else {
                this.menuLinkItems[i].className = '';
                rowWidth = nextFooterItemWidth;
            }
        }
    };

    setLanguage = (lang: string) => {
        this.props.analytics.track("clickevent", {location: "footer", category: "interaction", action: `language selector : ${lang}`});
        this.context.setLocale(lang);
    };

    render(): JSX.Element {
        return (
            <footer>
                <div className="container">
                    <div className="menu text-center" ref={this.footerContainer}>
                        <ul>
                            <li className="logo">
                                <img src={logo}  alt="Ubisoft+"/>
                            </li>
                            {
                                menuLinks.map((menuLink, key) => {
                                    return (
                                        <li key={key} ref={ref => {if(ref !== null) {(this.menuLinkItems[key] = ref)}}} className="footerLink">
                                            <a href={menuLink.url} target="_blank" rel="noopener noreferrer" onClick={() => this.trackLinkClick(menuLink.name)}>
                                                <FormattedMessage id={menuLink.label}/>
                                            </a>
                                        </li>
                                    )
                                })
                            }
                            <li className="languageSelector">
                                <UncontrolledDropdown>
                                    <DropdownToggle caret onClick={e => this.trackLanguagesDropdownOpen(e)}>
                                        {languageLabels[this.context.locale]}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {Object.keys(languageLabels).map(languageCode => {
                                            return (
                                                <DropdownItem key={languageCode} onClick={()=> this.setLanguage(languageCode)}>
                                                    {languageLabels[languageCode]}
                                                </DropdownItem>
                                            );
                                        })}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </li>
                        </ul>
                    </div>
                    <div className="copyright">
                        <FormattedMessage id="footer.copyright" values={{year: new Date().getFullYear()}}/>
                    </div>
                </div>
            </footer>
        );
    }

    trackLinkClick = (link: string) => {
        this.props.analytics.track("clickevent", {location: "footer", category: "action", action: link});
    };

    trackLanguagesDropdownOpen = (e: MouseEvent<HTMLButtonElement>) => {
        if (e.currentTarget.getAttribute('aria-expanded') === 'false') {
            this.props.analytics.track("clickevent", {location: "footer", category: "interaction", action: "language selector : open"});
        }
    }
}